var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-map',{style:(_vm.style),attrs:{"zoom":_vm.zoom,"center":_vm.center}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}}),_c('v-marker-cluster',{attrs:{"options":_vm.options}},_vm._l((_vm.coords),function(item,index){return _c('l-marker',{key:'marker-' + index,attrs:{"lat-lng":item,"icon":_vm.icon}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }